import React from 'react';
import { HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { PendingActionType } from '@/client';
import { getOfferOutcomeCopy, OFFER_OUTCOME_ICON, ResolvedOfferOutcome } from './chatPendingActionCopy';

interface ChatOfferOutcomeCardProps {
	/** The assistant's own answer text for this turn — the original offer, unchanged. Historical
	 * record of what was asked, not rewritten now that it's resolved. */
	responseText: string;
	offeredAction: PendingActionType;
	offerOutcome: ResolvedOfferOutcome;
}

/**
 * Groups a resolved offer with its result as one card, rather than showing the original offer
 * text as a dangling question next to a separate, mechanical "yes" reply bubble (which
 * `filterResolvedOfferReplies` drops from the thread entirely — this card is the only place the
 * outcome shows). See docs/local/chat-feature.md §C4.
 */
const ChatOfferOutcomeCard: React.FC<ChatOfferOutcomeCardProps> = (props: ChatOfferOutcomeCardProps) => {
	const { responseText, offeredAction, offerOutcome } = props;
	const message = getOfferOutcomeCopy(offeredAction, offerOutcome);
	const icon = OFFER_OUTCOME_ICON[offerOutcome];

	return (
		<VStack
			align="stretch"
			gap={3}
			borderWidth="1px"
			borderColor="border.subtle"
			borderRadius="2xl"
			p={4}
			maxW="lg"
		>
			<Text fontSize="sm" whiteSpace="pre-wrap">
				{responseText}
			</Text>
			<HStack gap={1.5} color="fg.muted" fontSize="xs">
				<Icon as={icon} boxSize={3.5} />
				<Text>{message}</Text>
			</HStack>
		</VStack>
	);
};

export default ChatOfferOutcomeCard;
